export default __webpack_public_path__ + "static/media/sustainable.1ad81739.svg";